// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"eg-770"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import {
  breadcrumbsIntegration,
  browserApiErrorsIntegration,
  functionToStringIntegration,
  globalHandlersIntegration,
  httpContextIntegration,
  init,
  makeFetchTransport,
  rewriteFramesIntegration,
} from "@sentry/nextjs";
import {
  sanitizeSentryEvent,
  sanitizeSentryTransaction,
} from "./utils/telemetrySanitization";
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

export const isNextPublicLocalHost = () => {
  const host = process.env.NEXT_PUBLIC_HOST;

  return !host || host.includes("localhost") || host.includes("127.0.0.1");
};
const isLocalHost = isNextPublicLocalHost();
if (!isLocalHost) {
  init({
    dsn:
      SENTRY_DSN ||
      "https://224494c4e1e04d4892e75c51db1d7600@o1246515.ingest.sentry.io/6418614",

    environment: process.env.NEXT_PUBLIC_ENVIRONMENT || "local",

    release:
      process.env.NEXT_PUBLIC_ENVIRONMENT +
      "-" +
      process.env.NEXT_PUBLIC_RESTAURANT_ID,

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.02,
    debug: process.env.NODE_ENV !== "production",
    sendDefaultPii: false,
    transport: makeFetchTransport,

    replaysSessionSampleRate: 0.5,

    replaysOnErrorSampleRate: 1.0,
    integrations: [
      rewriteFramesIntegration(),
      breadcrumbsIntegration(),
      functionToStringIntegration(),
      globalHandlersIntegration(),
      httpContextIntegration(),
      browserApiErrorsIntegration(),
    ],

    beforeSend(event) {
      // Skip if no exception data
      if (!event.exception || !event.exception.values) {
        return event;
      }

      const error = event.exception.values[0];

      // Filter ResizeObserver errors
      if (
        error.value &&
        error.value.includes(
          "ResizeObserver loop completed with undelivered notifications"
        )
      ) {
        return null;
      }

      // Filter network errors and not sent to sentry
      const networkErrorPatterns = [
        "NetworkError",
        "Failed to fetch",
        "Network request failed",
        "AbortError",
        "The Internet connection appears to be offline",
        "timeout",
        "CORS",
      ];

      if (
        error.value &&
        networkErrorPatterns.some((pattern) => error.value.includes(pattern))
      ) {
        return null;
      }

      // Filter node_modules errors
      if (event.exception.values[0].stacktrace) {
        const frames = event.exception.values[0].stacktrace.frames;
        if (frames && frames.length) {
          // Check if all frames are from node_modules
          const allFromNodeModules = frames.every(
            (frame) => frame.filename && frame.filename.includes("node_modules")
          );

          if (allFromNodeModules) {
            return null;
          }
        }
      }

      // Filters above decide whether to report at all; main's scrubber (#160)
      // then strips PII from whatever survives.
      return sanitizeSentryEvent(event);
    },

    beforeSendTransaction: sanitizeSentryTransaction,
  });
}
